import {
  COMBINED_MEDIA_DOWNLOAD_SIZES,
  ORIGINAL_MEDIA_DOWNLOAD_SIZES,
} from 'app/modules/posts/constants';
import { PostDetail } from 'types/PostDetail';
import {
  isDocumentAttachmentCard,
  isVideoAttachmentCard,
} from 'utils/attachments';

export const getMediaDownloadSizes = (post: PostDetail) => {
  const hasVideoOnly = post.attachments.cards.every(isVideoAttachmentCard);
  const hasDocumentOnly = post.attachments.cards.every(
    isDocumentAttachmentCard,
  );

  return hasVideoOnly || hasDocumentOnly
    ? ORIGINAL_MEDIA_DOWNLOAD_SIZES
    : COMBINED_MEDIA_DOWNLOAD_SIZES;
};
